import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import ClientsService from '../../services/ClientsService';
import { clientKeys } from '../queries/useClients';

/**
 * Mutation para atualizar dados do cliente
 */
export function useUpdateClient() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) => ClientsService.updateClient(data),
    onSuccess: (_data, variables) => {
      // Invalidar queries relacionadas ao cliente
      queryClient.invalidateQueries({
        queryKey: clientKeys.detail(variables.id),
      });
      queryClient.invalidateQueries({
        queryKey: clientKeys.status(variables.id),
      });

      toast.success('Atualizado com sucesso!');
    },
    onError: (error) => {
      console.error('Erro ao atualizar cliente:', error);
      toast.error(error.response?.data?.error || 'Erro ao atualizar!');
    },
  });
}

/**
 * Mutation para iniciar verificação (envia códigos e retorna URL de upload)
 */
export function useInitiateVerification() {
  return useMutation({
    mutationFn: (fileInfo) => ClientsService.initiateVerification(fileInfo),
    onSuccess: () => {
      toast.success('Códigos enviados para email e telefone!');
    },
    onError: (error) => {
      console.error('Erro ao iniciar verificação:', error);
      toast.error(
        error.response?.data?.error || 'Erro ao iniciar verificação!'
      );
    },
  });
}

/**
 * Mutation para verificar código de email
 */
export function useVerifyEmail() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (code) => ClientsService.verifyEmail(code),
    onSuccess: () => {
      toast.success('Email verificado com sucesso!');
      queryClient.invalidateQueries({
        queryKey: clientKeys.all,
      });
    },
    onError: (error) => {
      console.error('Erro ao verificar email:', error);
      toast.error(error.response?.data?.error || 'Código de email inválido!');
    },
  });
}

/**
 * Mutation para verificar código de telefone
 */
export function useVerifyPhone() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (code) => ClientsService.verifyPhone(code),
    onSuccess: () => {
      toast.success('Telefone verificado com sucesso!');
      queryClient.invalidateQueries({
        queryKey: clientKeys.all,
      });
    },
    onError: (error) => {
      console.error('Erro ao verificar telefone:', error);
      toast.error(
        error.response?.data?.error || 'Código de telefone inválido!'
      );
    },
  });
}

/**
 * Mutation para confirmar upload do documento
 */
export function useVerifyDocument() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (key) => ClientsService.verifyDocument(key),
    onSuccess: () => {
      toast.success('Verificação completa! Sua conta foi ativada.');
      queryClient.invalidateQueries({
        queryKey: clientKeys.all,
      });
    },
    onError: (error) => {
      console.error('Erro ao verificar documento:', error);
      toast.error(
        error.response?.data?.error || 'Erro ao confirmar documento!'
      );
    },
  });
}
